module.exports = __webpack_public_path__ + "img/aac.26aa582d.svg";